const guaranteedScope = "guaranteed";

export default {
  satisfactionGuaranteed: `${guaranteedScope}.satisfactionGuaranteed`,
  satisfactionGuaranteedSub: `${guaranteedScope}.satisfactionGuaranteedSub`,
  testimonialOne: `${guaranteedScope}.testimonialOne`,
  testimonialTwo: `${guaranteedScope}.testimonialTwo`,
  testimonialThree: `${guaranteedScope}.testimonialThree`,
};
